import i18next from 'i18next';

import { downloadProposalXls } from 'common/api/v1/proposals';
import showToast from 'common/utils/showToast';

import {
    DOWNLOAD_OFFER_XLS,
    DOWNLOAD_OFFER_XLS_FAILURE,
    DOWNLOAD_OFFER_XLS_SUCCESS,
    SET_IS_DOWNLOADING,
} from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

import downloadFile from './downloadFile';

export default (id, name = i18next.t('File')) =>
    (dispatch) => {
        dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](true));
        dispatch(multiTemplateReviewActions[DOWNLOAD_OFFER_XLS]());

        downloadProposalXls(id)
            .then((response) => {
                dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](false));
                dispatch(
                    multiTemplateReviewActions[DOWNLOAD_OFFER_XLS_SUCCESS](
                        response.data,
                    ),
                );
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                dispatch(downloadFile(name, url, 'xlsx'));
                showToast({ body: i18next.t('It was created successfully') });
            })
            .catch((error) => {
                dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](false));
                dispatch(
                    multiTemplateReviewActions[DOWNLOAD_OFFER_XLS_FAILURE](
                        error,
                    ),
                );
            });
    };
